// Contenedor admin: cabe en el ancho útil del layout (170vh forzaba scroll horizontal fuera de ~1366×768)
export const cajaContenedorAdminStyle = {
  width: 'calc(100% - 7vh)',
  maxWidth: '100%',
  boxSizing: 'border-box',
  height: '100%',
  marginLeft: '3vh',
  marginTop: '5vh',
  opacity: 1,
};